/**
 * C2 — map Sellix enrollment journeys onto Signals ABM List card/detail fields.
 */
import { applyJourneyToRnc } from "@/lib/rncJourney";

const AVATAR_COLORS = ["#4F46E5", "#16A34A", "#DC2626", "#3B82F6", "#14B8A6", "#F97316", "#0A66C2", "#7C3AED"];

function initialsFromName(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "AB";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

/** Map custom_leads API payload into the RNC-compatible card shape. */
export function buildAbmViewModel(lead, index = 0) {
  const company = lead?.companyName || "Untitled company";
  const city = lead?.city || "";
  const country = lead?.country || "";
  const location = [city, country].filter(Boolean).join(", ");
  return {
    id: lead?.id,
    company,
    contact: lead?.contactName || "—",
    location: location || "—",
    email: lead?.email || "—",
    phone: lead?.phone || "—",
    city,
    country,
    type: lead?.industry || "ABM List",
    units: lead?.jobTitle || "—",
    initials: initialsFromName(company),
    color: AVATAR_COLORS[index % AVATAR_COLORS.length],
    channel: "custom",
    campaignId: null,
    campaignName: null,
    workflowId: null,
    workflowVersion: null,
    workflowAssigned: false,
    signalWorkflow: null,
    assignedDate: lead?.uploadedAt || null,
    stepIndex: 0,
    progress: null,
    status: null,
    currentStep: null,
    nextStep: "None",
    remainingTime: "—",
    dateAdded: (lead?.uploadedAt || lead?.createdAt) || "—",
    lastActivity: (lead?.uploadedAt || lead?.createdAt) || null,
    notes: lead?.notes || "",
    website: lead?.website || "",
    state: lead?.state || "",
    jobTitle: lead?.jobTitle || "",
    sourceLabel: lead?.sourceLabel || "ABM List",
  };
}

export function applyJourneyToAbmLead(lead, journey, index = 0) {
  return applyJourneyToRnc(buildAbmViewModel(lead, index), journey);
}
